import MentoringWorkingRequests from './MentoringWorkingRequests.vue';

export default MentoringWorkingRequests;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/workingrequests/index.ts